import { ReactNode, useEffect } from "react"

import { setDocumentDarkMode } from "@podcastsoundboard/ps-lib/ui"

/**
 * Applies Tailwind dark mode. The wrapper div carries the `dark` class so
 * server-rendered markup is correct before hydration; the effect stamps the
 * class on <html> so portaled content (dialogs, tooltips) matches too.
 */
export default function ThemeRoot({
  darkModeEnabled,
  children,
}: {
  darkModeEnabled: boolean
  children: ReactNode
}) {
  useEffect(() => {
    setDocumentDarkMode(darkModeEnabled)
  }, [darkModeEnabled])

  return <div className={darkModeEnabled ? "dark" : undefined}>{children}</div>
}
